import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';

export default function Invite() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { user, profile, refreshProfile } = useAuth();
  const appliedRef = useRef(false);

  useEffect(() => {
    const inviteCode = (code ?? '').trim().toUpperCase();
    if (!inviteCode) {
      navigate('/', { replace: true });
      return;
    }

    localStorage.setItem('budgetai_pending_invite_code', inviteCode);

    if (!user || appliedRef.current) {
      navigate(`/register?invite=${encodeURIComponent(inviteCode)}`, { replace: true });
      return;
    }

    if (profile?.invite_code?.toUpperCase() === inviteCode) {
      localStorage.removeItem('budgetai_pending_invite_code');
      toast('Questo e il tuo link invito: condividilo con amici.', { icon: 'ℹ️' });
      navigate('/settings', { replace: true });
      return;
    }

    appliedRef.current = true;
    (async () => {
      const { error } = await supabase.rpc('apply_invite_code', { p_code: inviteCode });
      if (error) {
        const message = (error.message || 'Codice invito non valido').toLowerCase();
        if (message.includes('already used')) {
          localStorage.removeItem('budgetai_pending_invite_code');
          toast('Codice gia usato su questo account.', { icon: 'ℹ️' });
        } else if (message.includes('your own invite code')) {
          localStorage.removeItem('budgetai_pending_invite_code');
          toast('Non puoi usare il tuo stesso codice invito.', { icon: 'ℹ️' });
        } else {
          toast.error(error.message || 'Codice invito non valido');
        }
      } else {
        localStorage.removeItem('budgetai_pending_invite_code');
        await refreshProfile();
        toast.success('Invito applicato: +1 settimana di trial!');
      }
      navigate('/dashboard', { replace: true });
    })();
  }, [code, navigate, profile?.invite_code, refreshProfile, user]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center text-slate-300">
      Applicazione invito in corso...
    </div>
  );
}
